import { Checkbox } from 'primereact/checkbox';
import React, { useEffect, useState } from 'react';
import { formatDate } from '../../constants/DateUtil/DateUtil';
import { checkPackageSubscriptionOffer } from '../../services/PaymentOfferManagement/CheckPackageSubscriptionOffer';
import { getStoreLocalData } from '../../utils/localStorage';

const PackageSubscriptionOfferDefault = ({
  storeCustomerId,
  storeId,
  storeUserId,
  grandTotal,
  onChecked,
  enabledApplySubscriptionWithPackage,
  enabledAutoApplySubscriptionWithPackage,
  cartPackageData,
  enabledAmountRoundOff,
  b2BModelSelected,
  blockCheckoutInPackageSubscriptionLowBalance
}) => {

  const { storeLocalData } = getStoreLocalData();
  const [selectedItem, setSelectedItem] = useState([]);
  const [selectedItemAuto, setSelectedItemAuto] = useState({});
  const [showHide, setShowHide] = useState(false);

  const [subscriptionPackageOfferData, setSubscriptionPackageOfferData] =
    useState([]);

  const handleItemPress = () => {
    setShowHide(prev => !prev);
  };

  useEffect(() => {
    let isCancelled = false;

    const fetchData = async () => {
      const packageSubscriptionData = {
        grandTotal: Number(Number(grandTotal).toFixed(enabledAmountRoundOff)),
        storeCustomerId: storeCustomerId,
      };

      try {
        const response = await checkPackageSubscriptionOffer(
          storeId,
          storeCustomerId,
          packageSubscriptionData
        );

        if (isCancelled) return;

        if (!response.data.error) {
          const res = response.data;
          const ResNew = res.map(item => ({
            id: item?.packageOfferSubscriber?.id,
            value: item.discount,
            expireDate: item?.packageOfferSubscriber?.validTo,
            packagePercentage: item?.packageOfferSubscriber?.brandPackageOffer?.value,
            packageName: item?.packageOfferSubscriber?.brandPackageOffer?.name,
            leftDiscount: item?.packageOfferSubscriber?.leftDiscount,
          }));
          setSubscriptionPackageOfferData(ResNew);

          if (ResNew.length > 0 && blockCheckoutInPackageSubscriptionLowBalance) {
            // Pick the offer with the highest discount value
            const maxDiscount = ResNew.reduce((max, current) =>
              current.value > max.value ? current : max
              , ResNew[0]);

            setSelectedItemAuto(maxDiscount);

            if (!b2BModelSelected) {
              setSelectedItem([maxDiscount.id]);
            } else {
              setSelectedItem([]);
            }
          } else {
            setSelectedItemAuto({});
            setSelectedItem([]);
          }
        }
      } catch (err) {
        console.error('Error:', err);
      }
    };

    fetchData();

    return () => {
      isCancelled = true;
    };
  }, [grandTotal, storeId, storeCustomerId, enabledAmountRoundOff, b2BModelSelected]);

  // Notify parent whenever the effective selection changes.
  // Previously this call lived directly in the render body, which fired on
  // every render and could trigger an infinite update loop in the parent.
  useEffect(() => {
    if (!b2BModelSelected) {
      onChecked({
        selectedItemId: selectedItemAuto.id ?? null,
        selectedItemValue: selectedItemAuto.value ?? 0,
      });
    } else {
      onChecked({
        selectedItemId: null,
        selectedItemValue: 0,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [b2BModelSelected, selectedItemAuto]);

  const showPackageSubscriptionMessage =
    enabledApplySubscriptionWithPackage && cartPackageData?.length > 0;

  const handleStatusToggle = item => {
    let updatedItems;

    if (selectedItem.includes(item.id)) {
      // If already selected, deselect it
      updatedItems = selectedItem.filter(id => id !== item.id);
    } else {
      // Only one item can be selected at a time
      updatedItems = [item.id];
    }

    setSelectedItem(updatedItems);

    const isNowSelected = updatedItems.includes(item.id);

    onChecked({
      selectedItemId: isNowSelected ? item.id : null,
      selectedItemValue: isNowSelected ? item.value : null,
    });
  };

  return (
    subscriptionPackageOfferData?.length > 0 && (
      <div
        className="flex-1 shadow-2 px-3 mb-2"
        style={{
          backgroundColor: '#F6FAFF',
        }}
      >
        {!b2BModelSelected && (
          <div>
            <div
              className="flex flex-1 justify-content-between mx-2 py-2 cursor-pointer"
              onClick={() => handleItemPress()}
            >
              <div className="flex justify-content-start align-items-center flex-1 ">
                <img
                  src={'Laundy_App_Icons_Gifs/SettingIcons/gift.png'}
                  resizeMode="cover"
                  style={{
                    width: 20,
                    height: 20,
                  }}
                />
                <p className=" text-lg font-medium capitalize ml-2">
                  Package Subscription Offer{' '}
                  {showPackageSubscriptionMessage &&
                    !enabledAutoApplySubscriptionWithPackage &&
                    '(* Package Item also added in cart)'}
                </p>
              </div>
              <div>
                {!showHide ? (
                  <i
                    className="pi pi-angle-down"
                    style={{ fontSize: '25px', cursor: 'pointer', color: '#777' }}
                  ></i>
                ) : (
                  <i
                    className="pi pi-angle-up"
                    style={{ fontSize: '25px', cursor: 'pointer', color: '#777' }}
                  ></i>
                )}
              </div>
            </div>
            <div></div>

            {showHide && (
              <div
                className=" border-top-2"
                style={{
                  borderTopColor: '#C1C9D3',
                }}
              >
                <div className="mt-3 pb-3">
                  {subscriptionPackageOfferData.map(item => (
                    <div
                      key={item.id}
                      className=" flex my-1 mx-1 border-round-md shadow-4"
                      style={{
                        borderRadius: 5,
                        backgroundImage:
                          'radial-gradient(circle at left top, #FF5F6D, #FFC371)',
                        flex: 1,
                      }}
                    >
                      <div className="flex-row flex justify-content-between align-items-center py-1 px-2">
                        <p className=" text-lg text-white font-medium capitalize">
                          Discount {storeLocalData?.currencySymbol} {item.value} |{' '}
                          {item.packagePercentage + '%'}
                        </p>
                        <p className=" text-lg text-white font-medium capitalize">
                          {item.packageName}
                        </p>
                        <Checkbox
                          checked={selectedItem.includes(item.id)}
                          onChange={() => handleStatusToggle(item)}
                        ></Checkbox>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    )
  );
};

export default PackageSubscriptionOfferDefault;
